type SubscriptionLike = {
  status?: string | null;
  payment_status?: string | null;
};

export const hasActiveSubscriptionStatus = (subscriptions: SubscriptionLike[] = []) =>
  subscriptions.some((sub) => {
    const status = (sub.status || '').toLowerCase();
    const paymentStatus = (sub.payment_status || '').toLowerCase();

    return (
      status === 'active' ||
      status === 'pending_activation' ||
      status === 'completed' ||
      paymentStatus === 'active' ||
      paymentStatus === 'approved'
    );
  });
